import { when } from 'mobx';
import ControleGabineteService from '../services/ControleGabineteService';
import MinutaDevolvidaService from '../services/MinutaDevolvidaService';
import MotivoAndamentoService from '../services/MotivoAndamentoService';
import MovimentoService from '../services/MovimentoService';
import ParametroUsuarioService from '../services/ParametroUsuarioService';
import FiltroStore from './FiltroStore';
import GabineteStore from './GabineteStore';
import LayoutStore from './LayoutStore';
import NotificacaoStore from './NotificacaoStore';
import ParametroStore from './ParametroStore';
import ProcessoStore from './ProcessoStore';
import RouterStore from './RouterStore';
import UsuarioStore from './UsuarioStore';
import ControleGabineteStore from './ControleGabineteStore';


export default class RootStore {

    constructor(routingStore) {
        RouterStore.inicializar(routingStore);
    }

    async inicializarStoresSistema() {
        this.limparStoresSistema();
        if (!UsuarioStore.isUsuarioLogado) {
            UsuarioStore.inicializar();
        }
        const resultados = await Promise.allSettled([
            LayoutStore.inicializar(),
            FiltroStore.inicializar(),
            MovimentoService.carregarMovimentos(),
            MotivoAndamentoService.carregarMotivosAndamento()
        ]);

        resultados.forEach((resultado, indice) => {
            if (resultado.status === 'rejected') {
                console.error(`Falha na inicialização da store/serviço [${indice}]`, resultado.reason);
            }
        });
        when(() => UsuarioStore.localizacao !== undefined, async () => {
            // Garante carga dos usuários do gabinete no bootstrap (nome do responsável no escaninho).
            try {
                await GabineteStore.inicializar();
            } catch (erro) {
                console.error('Falha ao inicializar GabineteStore', erro);
            }

            try {
                await ControleGabineteService.atualizarControlesGabinete();
            } catch (erro) {
                console.error('Falha ao atualizar controles do gabinete', erro);
            }

            try {
                await ParametroStore.inicializar();
            } catch (erro) {
                console.error('Falha ao inicializar ParametroStore', erro);
            }

            try {
                await ParametroUsuarioService.inicializarParametroStore();
            } catch (erro) {
                console.error('Falha ao inicializar parâmetros do usuário', erro);
            }

            try {
                await MinutaDevolvidaService.verificarSeExistemMinutasDevolvidas();
            } catch (erro) {
                console.error('Falha ao verificar minutas devolvidas', erro);
            }
        });
    }

    inicializarStoresEspelho() {
        ProcessoStore.limpar();
        UsuarioStore.inicializar();
    }

    inicializarStoresUsuario() {
        //TODO
    }

    limparStoresSistema() {
        FiltroStore.limparFiltros();
        NotificacaoStore.limpar();
        ProcessoStore.limpar();
        ControleGabineteStore.limpar();
    }

    limparStores() {
        this.limparStoresSistema();
        UsuarioStore.limpar();
        RouterStore.limpar();
    }
    
}
